import { useMemo } from "react";
import { MapContainer, TileLayer, Marker, Popup, Polyline } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Avoid the default Leaflet marker icon 404 in bundler builds.
const baseIcon = (color) =>
  L.divIcon({
    className: "ekin-marker",
    html: `<span style="background:${color};display:block;width:18px;height:18px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);border:2px solid #fff;box-shadow:0 1px 3px rgba(0,0,0,.35)"></span>`,
    iconSize: [22, 22],
    iconAnchor: [11, 22],
    popupAnchor: [0, -22],
  });

const ORIGIN_ICON = baseIcon("#1A3A8C");
const DESTINATION_ICON = baseIcon("#059669");

export default function RouteMap({ origin, destination, height = 240 }) {
  const points = useMemo(() => {
    const arr = [];
    if (origin) arr.push([origin.lat, origin.lng]);
    if (destination) arr.push([destination.lat, destination.lng]);
    return arr;
  }, [origin, destination]);

  if (points.length === 0) return null;

  // Center on the single point if only one, else midpoint
  const center = points.length === 1
    ? points[0]
    : [(points[0][0] + points[1][0]) / 2, (points[0][1] + points[1][1]) / 2];

  // Use a wider zoom if we only have one point
  const zoom = points.length === 1 ? 14 : undefined;
  const bounds = points.length === 2 ? points : undefined;

  return (
    <div
      className="border border-zinc-200 overflow-hidden"
      style={{ height }}
      data-testid="route-map"
    >
      <MapContainer
        center={center}
        zoom={zoom}
        bounds={bounds}
        boundsOptions={{ padding: [30, 30] }}
        scrollWheelZoom={false}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {origin && (
          <Marker position={[origin.lat, origin.lng]} icon={ORIGIN_ICON}>
            <Popup>Inicio de ruta</Popup>
          </Marker>
        )}
        {destination && (
          <Marker position={[destination.lat, destination.lng]} icon={DESTINATION_ICON}>
            <Popup>Punto de entrega</Popup>
          </Marker>
        )}
        {points.length === 2 && (
          <Polyline positions={points} pathOptions={{ color: "#1A3A8C", weight: 3, dashArray: "6 6" }} />
        )}
      </MapContainer>
    </div>
  );
}
